module.exports = __webpack_public_path__ + "img/2b2eee62b786b3c650d05fb7adb85afb.png";